/**
 * csv — minimal RFC-4180 serialization (the pre-billing "Download for
 * billing" export; no dependency per the boring-filter discipline,
 * tools/imports/_lib/csv.ts:7-11 — that module READS operator CSVs in
 * node; this one WRITES a browser download, so they stay separate).
 *
 * Escaping: a field containing a quote, comma, CR, or LF is wrapped in
 * double quotes with inner quotes doubled — invoice-line summaries are
 * free prose and routinely carry commas/newlines.
 */

/** Escape ONE field per RFC 4180. */
export function escapeCsvField(value: string): string {
  if (/[",\r\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

/** Serialize rows (header included by the caller) to CRLF-joined CSV. */
export function buildCsv(rows: ReadonlyArray<ReadonlyArray<string>>): string {
  return rows.map((r) => r.map(escapeCsvField).join(',')).join('\r\n') + '\r\n';
}

/** Hand the browser the CSV as a file to save. The Pre-billing tab's
 *  per-client download and the all-clients billing file both leave
 *  through here, so the two downloads cannot differ in mechanism. */
export function downloadCsvFile(filename: string, csv: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
